import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { useSelector } from "react-redux";
// @mui
import { Card, Stack, Button, Container, Typography } from "@mui/material";

// components
import { Edit } from "@mui/icons-material";
import { GridActionsCellItem } from "@mui/x-data-grid";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import Protected from "../protected/Protected";
// sections
import CustomTable from "../components/data-table/CustomDataTable";
import { useDeleteRoleMutation, useGetRolesQuery } from "../redux/services/role.service";
import RoleForm from "../sections/@dashboard/role/role.form";
import { selectAbility } from "../redux/slices/casl.slice";
import CustomDeleteConfirmation from "../components/dialog/CustomDeleteConfirmation";
// ----------------------------------------------------------------------

export default function RolePage() {
  const ability = useSelector(selectAbility);

  const [deleteRole, { isLoading: isDeleting }] = useDeleteRoleMutation();

  const [openRoleForm, setOpenRoleForm] = useState(false);

  const [openRow, setOpenRow] = useState(null);

  const [edit, setEdit] = useState(false);

  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);

  const handleCloseForm = () => {
    setOpenRoleForm(false);
    setEdit(false);
  };

  return (
    <Protected>
      <Helmet>
        <title> Role </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Role
          </Typography>
          {ability.can("post", "Role") && (
            <Button
              variant="contained"
              onClick={setOpenRoleForm}
              startIcon={<Iconify icon="eva:plus-fill" />}
            >
              New Role
            </Button>
          )}
          {(ability.can("patch", "Role") || ability.can("post", "Role")) && (
            <RoleForm
              open={openRoleForm}
              onClose={handleCloseForm}
              edit={edit}
              openRow={openRow}
            />
          )}
        </Stack>

        <Card>
          <Scrollbar>
            <CustomTable
              canSelect
              useDataQuery={useGetRolesQuery}
              tableName="Role"
              searchLabel="Search Role..."
              searchCols={["name"]}
              actions={
                ability.can("patch", "Role") || ability.can("delete", "Role")
                  ? {
                      field: "actions",
                      headerName: "Action",
                      type: "actions",
                      getActions: ({ row }) =>
                        [
                          ability.can("patch", "Role") ? (
                            <GridActionsCellItem
                              key="edit"
                              icon={<Edit />}
                              label="Edit"
                              showInMenu
                              onClick={() => {
                                setOpenRow(row);
                                setEdit(true);
                                setOpenRoleForm(true);
                              }}
                            />
                          ) : null,
                          ability.can("delete", "Role") ? (
                            <GridActionsCellItem
                              key="delete"
                              sx={{
                                color: "error.main",
                              }}
                              icon={
                                <Iconify
                                  color="error.main"
                                  icon="eva:trash-2-outline"
                                />
                              }
                              label="Delete"
                              showInMenu
                              onClick={() => {
                                setOpenRow(row);
                                setOpenDeleteConfirmation(true);
                              }}
                            />
                          ) : null,
                        ].filter((action) => action !== null),
                    }
                  : null
              }
            />
          </Scrollbar>
        </Card>
      </Container>

      {ability.can("delete", "Role") && (
        <CustomDeleteConfirmation
          open={openDeleteConfirmation}
          onClose={() => setOpenDeleteConfirmation(false)}
          tableName="Role"
          nameKey="name"
          deleteFunc={deleteRole}
          row={openRow}
          isLoading={isDeleting}
        />
      )}
    </Protected>
  );
}
